import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import css from 'css';

import Container from 'partials/Container';
import AnimateIn from 'partials/AnimateIn';
import SmartLink from 'partials/SmartLink';
import Image from 'partials/Image';
import { H1, H3, h3Styles } from 'partials/typography';
import { Button } from 'partials/formElements';
import { Input } from 'partials/formElements';
import SearchIcon from 'images/SearchIcon';

import {
    setProductSearchKeyword,
    setBookingVisibility,
    setBookingProgressCollapsedValue,
    setCartCollapsedValue,
    setBookingReference,
    setEditedBookingTimeSlotBackup,
    setBookingStep,
    setBookingMeetingType,
} from 'store';

const ModuleWrapper = styled.article`
    position: relative;
    background: #fff;
    padding-top: ${props => props.imagePositioin === 'vertical' ? 40 : 0}px;
    margin-top: ${props => props.imagePositioin !== 'vertical' ? -130 : 0}px;

    @media(max-width: 767px) {
        padding-top:0;
        margin-top:0;
    }

    .background-image {
        position:absolute;
        top:0;
        left:0;
        bottom:0;
        right:0;
        padding-top: 0;

        @media(max-width: 767px) {
            position:relative;
            height:380px;
        }
    }
`

const Main = styled.div`
    width: ${props => props.imagePositioin === 'vertical' ? 62 : 100}%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-right: ${props => props.imagePositioin === 'vertical' ? 40 : 0}px;
    padding-top: ${props => props.imagePositioin !== 'vertical' ? 210 : 0}px;
    padding-bottom: ${props => props.imagePositioin !== 'vertical' ? 80 : 0}px;

    @media(max-width: 767px) {
        width:100%;
        padding: 30px 0;
        ${props => props.hasSidebar ? `
            order:2;
        ` : ``}
    }

    ${props => props.imagePositioin === 'full_screen' ? `
        height: 100vh;
        padding-top: 130px;
        padding-bottom: 130px;

        @media(max-width: 767px) {
            height:auto;
            padding: 30px 0;
        }
    ` : ``}

    .intro-text {
        padding-top: ${props => props.imagePositioin === 'vertical' ? 40 : 0}px;

        @media(max-width: 767px) {
            padding-top: 0;
        }

        ${props => props.imagePositioin === 'full_screen' ? `
            height: 100%;
            justify-content: center;
            display: flex;
            flex-direction: column;
            align-items: flex-start;

            @media(max-width: 767px) {
                height: auto;
            }
        ` : ``}

        h1 {
            margin-bottom:10px;
            color: ${props => props.textColor === 'white' ? 'white' : css.colors.main};
            @media(max-width: 767px) {
                color: ${css.colors.main};
            }
        }

        h3 {
            ${h3Styles}
            margin-bottom: 40px;
            color: ${props => props.textColor === 'white' ? 'white' : css.colors.main};

            @media(max-width: 1200px) {
                br {
                    display: none;
                }
            }

            @media(max-width: 767px) {
                margin-bottom: 30px;
                color: ${css.colors.main};
            }
        }
    }
`

const QuickLinks = styled.ul`
	${props => props.textColor ? `
		color: ${props.textColor};
    `: ``}
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	padding-bottom:55px;
	padding-top: 180px;

	@media(max-width: 1200px) {
		padding-top: 55px;
	}

	@media(max-width: 767px) {
		padding-top: 40px;
		padding-bottom: 20px;
		color: #002857;
	}

	li {
		width: calc(100% / ${props => props.length});
		overflow: hidden;
		display: flex;

		@media(max-width: 1200px) {
			width: 100%;
			margin-bottom:30px;
			&:last-child {
				margin-bottom:0;
			}
		}

		a, .quick-link-button {
			padding: 12px 0 24px 24px;
			position: relative;
			overflow: hidden;
			display: flex;
			flex-direction: column;

			@media(max-width: 1200px) {
				padding: 0 0 0 24px;
			}

			&:before, &:after {
				content: '';
				display: block;
				position: absolute;
				top:0;
				left:0;
				height:100%;
				width: 8px;
				background: ${css.colors.blue};
				opacity:.11;
			}

			&:after {
				height:58px;
				opacity:1;
				transition: all .2s ease-in-out;

				@media(max-width: 1200px) {
					height:30px;
				}
			}

			h3 {
				margin-bottom:15px;
				text-decoration: underline;
			}

			&:hover, &:focus {
				&:after {
					height:100%;
				}
			}
		}
	}
`

const QuickLinkButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    text-align: left;
    width: 100%;
    color: inherit;
    font: inherit;
    outline: inherit;
    padding: 0;
    &.quick-link-button { display: flex; }
`

const Aside = styled.div`
    width: 38%;
    max-height: 300px;

    @media(max-width: 767px) {
        height:380px;
        min-height:380px;
        min-width: calc(100% + 40px);
        margin-left: -20px;
        overflow: hidden;
        display: flex;
        order: 1;
    }
`

const VideoWrapper = styled.div`
    padding-top: calc(100% * ${props => props.p});
    height:0;
    width: 100%;

    @media(max-width: 767px) {
        padding-top:0;
        height:380px;
    }

    video {
        width:100%;
        height:auto;
        position:absolute;
        top:0;
        left:0;
        bottom:0;
        right:0;
        padding-top: 0;

        @media(max-width: 767px) {
            top: 50%;
            transform: translateY(-50%);
        }
    }
`

const CoursesSearchField = styled.div`
    + h3 {
        margin-top: 15px
    }

    @media(max-width: 767px) {
        + h3 {
            display: none;
        }
    }

    form {
        margin: 40px 0 0;
        max-width: 740px;
        position: relative;

        @media(max-width: 767px) {
            margin: 30px 0 0 0;
        }

        input {
            background: #EEEEEE;
            height:56px;
            width:100%;
            font-size:24px;
            border: none;
            border-bottom: 2px solid ${css.colors.blue};
            padding-left:16px;
            padding-right: 55px;

            &::placeholder {
                color: ${css.colors.main};
                opacity:1;
            }
        }

        svg {
            position:absolute;
            top: 50%;
            transform: translateY(-50%);
            right:15px;
        }
    }
`

class Intro extends Component {
    componentDidMount() {
        this.props.setProductSearchKeyword('');
    }

    _onCourseSearchInputChange(element) {
        const value = element.target.value === ' ' ? '' : element.target.value;

        this.props.setProductSearchKeyword(value);
    }

    _onQuickLinkCLick(element, bookingTrigger) {
        if (bookingTrigger) {
            element.preventDefault();
            // stopImmediatePropagation cancels ALL remaining document-level listeners
            // (including the App.js native click handler), not just React's synthetic bubbling.
            // stopPropagation() alone is not enough because both listeners share document level.
            if (element.nativeEvent) {
                element.nativeEvent.stopImmediatePropagation();
                console.log('[Intro] stopImmediatePropagation called for bookingTrigger:', bookingTrigger);
            } else {
                console.warn('[Intro] nativeEvent not available — stopImmediatePropagation skipped');
            }

            this.props.setBookingStep(2);
            this.props.setBookingVisibility(true);
            this.props.setBookingProgressCollapsedValue(false);
            this.props.setCartCollapsedValue(true);
            this.props.setBookingReference(null);
            this.props.setEditedBookingTimeSlotBackup(null);
        }

        if (bookingTrigger === 'open_with_physical_meeting') {
            this.props.setBookingMeetingType('Fysisk møte');
        }

        if (bookingTrigger === 'open_with_video_meeting') {
            this.props.setBookingMeetingType('Videomøte');
        }

        if (bookingTrigger === 'open_with_phone_meeting') {
            this.props.setBookingMeetingType('Telefon');
        }
    }

    render() {
        const { data, page, productSearchKeyword } = this.props;

        const pageHasCoursesModule = page.acf.modules.filter(module => module.acf_fc_layout === 'courses').length || null;

        const hasSidebar = (data.image || data.video) && data.image_position === 'vertical';

        return (
            <ModuleWrapper imagePositioin={data.image_position} >
                <AnimateIn>
                    {data.image && data.image_position !== 'vertical' &&
                        <Image image={data.image} className="background-image" background />
                    }

                    <Container flex wrap>
                        <Main imagePositioin={data.image_position} textColor={data.text_color} hasSidebar={hasSidebar}>
                            <div className="intro-text">
                                <H1> {data.title} </H1>
                                {pageHasCoursesModule &&
                                    <CoursesSearchField>
                                        <form onSubmit={e => e.preventDefault()}>
                                            <Input placeholder="Søk etter fag her" value={productSearchKeyword} onChange={this._onCourseSearchInputChange.bind(this)} />
                                            <SearchIcon />
                                        </form>
                                    </CoursesSearchField>
                                }
                                <h3 dangerouslySetInnerHTML={{ __html: data.subtitle }} />
                                {data.button.url &&
                                    <Button
                                        link={data.button.url}
                                        red={~data.button_style.indexOf('red')}
                                        blue={~data.button_style.indexOf('blue')}
                                        white={~data.button_style.indexOf('white')}
                                        main={~data.button_style.indexOf('dark')}
                                        outline={~data.button_style.indexOf('outline')}
                                    >{data.button.title}</Button>
                                }
                            </div>
                            {(data.image_position === 'vertical' || data.image_position === 'full_screen') && data.quick_links && data.quick_links.length > 0 &&
                                <QuickLinks length={data.quick_links.length} textColor={data.text_color}>
                                    {data.quick_links.map((item, i) => (
                                        <li key={'ql-' + i}>
                                            {item.booking_trigger
                                                ? (
                                                    /* booking-trigger links must NOT be <a> tags.
                                                       GTM's Link Click listener fires on <a> before
                                                       React, causing a hard reload that kills the iframe. */
                                                    <QuickLinkButton className="quick-link-button" onClick={e => this._onQuickLinkCLick(e, item.booking_trigger)}>
                                                        <H3>{item.title}</H3>
                                                        <p>{item.description}</p>
                                                    </QuickLinkButton>
                                                ) : (
                                                    <SmartLink to={item.link} onClick={e => this._onQuickLinkCLick(e, item.booking_trigger)}>
                                                        <H3>{item.title}</H3>
                                                        <p>{item.description}</p>
                                                    </SmartLink>
                                                )
                                            }
                                        </li>
                                    ))}
                                </QuickLinks>
                            }
                        </Main>
                        {hasSidebar &&
                            <Aside>
                                {!data.video && <Image image={data.image} size="large" background={window.matchMedia("(max-width: 768px)").matches} />}
                                {data.video &&
                                    <VideoWrapper p={data.video.height / data.video.width}>
                                        {data.image && <Image image={data.image} className="background-image" background />}
                                        <video autoPlay loop muted playsInline>
                                            <source src={data.video.url} type="video/mp4" />
                                        </video>
                                    </VideoWrapper>
                                }
                            </Aside>
                        }
                    </Container>
                </AnimateIn>
            </ModuleWrapper>
        );
    }
}

const mapStateToProps = state => ({
    productSearchKeyword: state.productSearchKeyword,
});

const actions = {
    setProductSearchKeyword,
    setBookingVisibility,
    setBookingProgressCollapsedValue,
    setCartCollapsedValue,
    setBookingReference,
    setEditedBookingTimeSlotBackup,
    setBookingStep,
    setBookingMeetingType,
}

export default connect(mapStateToProps, actions)(Intro);


// WEBPACK FOOTER //
// ./src/partials/modules/Intro.js